import store from "@/store";
export function actionCheck(checkname) {
  return accessHave(checkname) !== false;
}
/**判断权限字段是否存在*/
export function accessHave(name) {
  console.log("name", name);
  const access = store.state.main.functions;
  console.log("access", access);
  if (access.indexOf(name) > -1) {
    return true;
  } else {
    return false;
  }
}
export default {
  actionCheck,
};
